import "./HelpCenterHeader.scss"

import { Link } from "react-router-dom"

import Icon from "@/shared/components/intrinsic/Icon/Icon"

import usePdfExport from "../../hooks/usePdfExport"
import { HelpCenterHeaderProps } from "../../types"

function HelpCenterHeader(props: HelpCenterHeaderProps) {
  const { exportToPdf, isPending } = usePdfExport(props.contentRef)

  return (
    <header className="help-center-header">
      {props.backPath && (
        <Link to={props.backPath} className="help-center-header__back">
          <Icon name="chevron-left" />
          <span>{props.backLabel || "Back"}</span>
        </Link>
      )}
      <div className="help-center-header__title-row">
        <div className="help-center-header__title-content">
          {props.logo ? (
            <div className="help-center-header__logo">
              <img src={props.logo} alt={`${props.title} logo`} />
            </div>
          ) : props.icon ? (
            <div className="help-center-header__icon">
              <Icon name={props.icon} />
            </div>
          ) : null}
          <div className="help-center-header__titles">
            <h1 className="help-center-header__title">{props.title}</h1>
            {props.subtitle && (
              <p className="help-center-header__subtitle">{props.subtitle}</p>
            )}
          </div>
        </div>
        {!props.hidePdfDownload && (
          <div className="help-center-header__actions">
            <div
              className={`help-center-header__download-card ${isPending ? "help-center-header__download-card--pending" : ""}`}
              onClick={() => !isPending && exportToPdf(props.title)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  !isPending && exportToPdf(props.title)
                }
              }}
            >
              <div className="help-center-header__download-text">
                <div className="help-center-header__download-label">Download:</div>
                <div className="help-center-header__download-title">{props.title} PDF</div>
                <div className="help-center-header__download-hint">
                  {isPending ? "Generating PDF..." : "Click to download your setup file."}
                </div>
              </div>
              <div className="help-center-header__download-icon">
                <img src="/static/wiki/downloadPDF.png" alt="PDF Download" />
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}

export default HelpCenterHeader
